import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AddAddressParams } from "../../../domain/entities/pending-confirmation";
import { type PendingConfirmationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** Registers an "Otra dirección" and resolves to the new address id. */
export const addAddress = createAsyncThunk<
  string,
  AddAddressParams,
  { dispatch: PendingConfirmationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.ADD_ADDRESS, async (params, { extra }) => {
  return await extra.contactCenterRepo.addAddress(params);
});
